
exports.mockService = () ->
    mocked = null
    inject ($q) ->
        mocked = {
            _query: (result) ->
                defer = $q.defer()
                defer.resolve(result)
                return defer.promise
        }

    return mocked
